









/* importing all the components needed in the page */
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import {
  SwContentToolbarExpand,
  ContentToolbarExpandFilterBlock,
} from '@libs-uuif/shared/sw-content-toolbar';
import { VNode, CreateElement } from 'vue';
import DeliveryFilter from './delivery-filter.vue';
import StatusFilter from './status-filter.vue';
import ReportTypeFilter from './report-type-filter.vue';
import ProductFilter from './product-filter.vue';

const cssPrefix: string = 'report-filter';

@Component({
  components: {
    SwContentToolbarExpand,
    ReportTypeFilter,
    StatusFilter,
    DeliveryFilter,
  },
})
export default class ReportFilter extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ default: false }) expandVisible: boolean;

  /*
    @desc Returns layout for Filter dropdown.
  */
  filterBlockGrid: ContentToolbarExpandFilterBlock[][] = [
    [
      {
        title: this.$t('common.product')
        .toString(),
        // tslint:disable-next-line
        content: (h: CreateElement) => {
          return (
            <div>
              <ProductFilter></ProductFilter>
            </div>
          ) as VNode;
        },
        width: 200,
        noPadding: true,
      },
      {
        title: this.$t('spog.unifiedInsights.reportType')
        .toString(),
        // tslint:disable-next-line
        content: (h: CreateElement) => {
          return (
            <div>
              <ReportTypeFilter></ReportTypeFilter>
            </div>
          ) as VNode;
        },
        width: 200,
        noPadding: true,
      },
      {
        title: this.$t('spog.unifiedInsights.reportType')
        .toString(),
        // tslint:disable-next-line
        content: (h: CreateElement) => {
          return (
            <div>
              <DeliveryFilter></DeliveryFilter>
            </div>
          ) as VNode;
        },
        width: 200,
        noPadding: true,
      },
      {
        title: this.$t('common.status')
        .toString(),
        // tslint:disable-next-line
        content: (h: CreateElement) => {
          return (
            <div>
              <StatusFilter></StatusFilter>
            </div>
          ) as VNode;
        },
        width: 400,
        noPadding: true,
      },
    ],
  ];
}
